import Navbar from "./Navbar";
import { collectionCarouselCards } from "../data/content";
import styles from "./CollectionDetail.module.css";

export default function CollectionDetail({ collectionId }) {
  const collection = collectionCarouselCards.find((card) => card.id === collectionId);

  if (!collection) {
    return (
      <main className={styles.page}>
        <Navbar />
        <section className={styles.notFound}>
          <p className={styles.eyebrow}>Coleção não encontrada</p>
          <h1>Essa coleção ainda não existe.</h1>
          <a className={styles.backButton} href="/#collection">
            ← voltar para coleções
          </a>
        </section>
      </main>
    );
  }

  return (
    <main className={styles.page} aria-label={`Página da coleção ${collection.title}`}>
      <Navbar />

      <section className={styles.hero}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>{collection.eyebrow}</p>
          <h1>{collection.title}</h1>
          <p className={styles.lead}>{collection.longDescription}</p>
          <p className={styles.details}>{collection.details}</p>
        </div>

        <div className={styles.heroImage}>
          <img src={collection.image} alt={collection.title} />
        </div>
      </section>

      <section className={styles.infoGrid}>
        <article className={styles.infoCard}>
          <span>Descrição curta</span>
          <p>{collection.description}</p>
        </article>

        <article className={styles.infoCard}>
          <span>Materiais e técnicas</span>
          <p>{collection.materials}</p>
        </article>
      </section>

      <section className={styles.gallery} aria-label="Galeria da coleção">
        {collection.gallery.map((image) => (
          <img key={image} src={image} alt={`${collection.title} - imagem da galeria`} />
        ))}
      </section>

      <a className={styles.backButton} href="/#collection">
        ← voltar para coleções
      </a>
    </main>
  );
}
